import React, { useCallback } from "react";
import ModalWrapper from "..";
import { Button } from "../../button";
import toast from "react-hot-toast";
import useAuthStore from "../../../store/Auth";
import { useDeleteGateById } from "../../../hooks/common/mutation";
import { useTranslation } from "react-i18next";
import { DELETE_STATUSES } from "../../../constants/common";

interface DeleteGateModalProps {
  gateId: number;
  isOpen: boolean;
  onOpenChange: () => void;
}

const DeleteGateModal = ({
  gateId,
  isOpen,
  onOpenChange,
}: DeleteGateModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync: DeleteGateById, isPending: isDeleteGateByIdLoading } =
    useDeleteGateById();

  const user = useAuthStore((state) => state.user);

  const handleDeleteGate = useCallback(async () => {
    try {
      if (user?.user_id) {
        const body = {
          encryptedId: gateId.toString(),
        };

        await DeleteGateById(body);
        toast.success(t("gateDeleted"));
      }
    } catch (error: any) {
      if (error.result.deleteStatus === DELETE_STATUSES.USED_IN_APPOINTMENT) {
        toast.error(t("gateNotDeletedUsedByAppointment"));
      } else {
        toast.error(t("somethingWentWrong"));
      }
    } finally {
      onOpenChange();
    }
  }, [DeleteGateById, gateId, onOpenChange, t, user?.user_id]);

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col gap-8 justify-center items-center">
        <p className="text-lg md:text-2xl font-medium">
          {t("confirmDeleteGate")}
        </p>

        <div className="flex gap-1 items-center">
          <Button
            onClick={handleDeleteGate}
            isLoading={isDeleteGateByIdLoading}
            className=" bg-red-600 hover:bg-red-700"
          >
            {t("delete")}
          </Button>

          <Button onClick={onOpenChange}>{t("close")}</Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(DeleteGateModal);
